<div *transloco="let t" class="col grid-item">
    <div class="order-card position-relative gap-2">

      <div class="d-flex justify-content-between align-items-center">
       <app-amount-status-badge [amountStatus]="amountStatus"/>

        <p class="fs-12 color-slate-400">Order ID #{{registration?.id}}</p>
      </div>

      <div class="d-flex flex-column gap-1">
        <p class="trim-text-second-line fw-500">
          <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [bsLabel]="race?.nameBs"
                               [itLabel]="race?.nameIta" [siLabel]="race?.nameSlo" [srLabel]="race?.nameSr"
                               [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages" [isUpperCase]="true"/>
        </p>
        <p class="fw-400 color-slate-600">
          <app-event-date-display [start]="race?.raceStart" [end]="race?.raceEnd" class="grey-600"/>
        </p>
      </div>


      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-start align-items-center gap-2">
          <p>
            {{ (registration!.totalAmountWithDiscount ?? 0)| myCurrency:registration!.currencyCode:true }}
          </p>
        </div>
        <div (click)="onOpenOrder()">
          <img src="assets/icons/icons-alt/chevron-right.svg" alt="Open" class="card-body__icon py-1 me-2"/>
        </div>
      </div>
    </div>
</div>
